import { useContext, useEffect, useState } from "react";
import Login from "./Login";
import APIContext from "../hooks/API";

const Authorized = ({ children }) => {
	const [loading, setLoading] = useState(true);
	const { authToken } = useContext(APIContext);
	useEffect(() => {
		setTimeout(() => setLoading(false), 200);
	}, [loading, setLoading]);
	return <>{loading ? <Loading /> : !authToken ? <Login /> : children}</>;
};

const Loading = () => (
	<div className="loading-screen">Loading&hellip;</div>
);

export default Authorized;
